import { atom } from 'jotai';

// Removed profilePicLinkAtom - using Zustand userDataStore.userData.image instead
export const ownedItemNameAtom = atom('');
export const userProfileAtom = atom(null);
export const profileImageLoadingAtom = atom(false);
